import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { normalizeLanguageCode, resolveInitialLanguage } from "./utils/language";

const translationLoaders = {
  ru: () => import("./locales/ru/translation.json"),
  uk: () => import("./locales/uk/translation.json"),
};

const lazyTranslationsBackend = {
  type: "backend",
  read(language, namespace, callback) {
    const normalizedLanguage = normalizeLanguageCode(language);
    const loadTranslation = translationLoaders[normalizedLanguage] || translationLoaders.ru;

    loadTranslation()
      .then((module) => callback(null, module.default || module))
      .catch((error) => callback(error, null));
  },
};

i18n
  .use(lazyTranslationsBackend)
  .use(initReactI18next)
  .init({
    lng: resolveInitialLanguage(),
    fallbackLng: "ru",
    supportedLngs: ["ru", "uk"],
    load: "languageOnly",
    ns: ["translation"],
    defaultNS: "translation",
    interpolation: {
      escapeValue: false
    },
    react: {
      useSuspense: false
    }
  });

export default i18n;
